<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-container fluid>
        <v-row>
            <v-col cols="9">
                <v-textarea
                    v-model="complaint.correctiveMeasures"
                    label="Środki korygujące niezgodność"
                    outlined
                    no-resize
                    :rows="4"
                    :disabled="isReadOnly"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'RecommendationsTab',

    props: {
        complaint: {
            type: Object,
            default: null,
        },
        isReadOnly: {
            type: Boolean,
        },
    },
}
</script>
